import React, { ReactNode } from "react";
import styles from "./style.module.scss";

interface ILinkBtn {
  content: string | ReactNode;
  handleClick: () => void;
  isActive?: boolean;
  styleInLine?: React.CSSProperties;
}

const LinkBtn: React.FC<ILinkBtn> = ({
  content,
  handleClick,
  isActive = false,
  styleInLine = {},
}) => {
  return (
    <button
      style={{
        flexShrink: 0,
        ...styleInLine,
      }}
      onClick={handleClick}
      className={`${styles["link-btn"]} ${isActive && styles["active-btn"]}`}
    >
      {content}
    </button>
  );
};

export default LinkBtn;
